<template>
    <b-navbar toggleable="md" class="purple-background" type="dark" sticky>
        <b-container>
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand href="#">
                <img src="@/assets/favicon.png" width="30" height="30" class="d-inline-block align-top">
            </b-navbar-brand>
            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                    <b-nav-item :to="{name:'recents'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Recientes
                    </b-nav-item>
                    <b-nav-item :to="{name:'directory'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Directorio
                    </b-nav-item>
                    <b-nav-item-dropdown text="Trivia" v-show="$store.getters.auth" exact exact-active-class="active">
                      <!--<b-dropdown-item :to="{name:'trivia'}">Jugar</b-dropdown-item>-->
                        <b-dropdown-item :to="{name:'trivia-ranking'}">Ranking</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <!--<b-nav-item :to="{name:'trivia'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Trivia
                    </b-nav-item>-->
                    <b-nav-item :to="{name:'favorites'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Favoritos
                    </b-nav-item>
                    <!--<b-nav-item :to="{name:'chat'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Chat
                    </b-nav-item>-->
                    <!--<b-nav-item :to="{name:'news'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Noticias
                    </b-nav-item>-->
                    <!--<b-nav-item :to="{name:'openings'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Openings
                    </b-nav-item>-->
                    <b-nav-item-dropdown text="Chat y más" v-show="$store.getters.auth" right>
                        <b-dropdown-item :to="{name:'chat'}">Chat</b-dropdown-item>
                        <b-dropdown-item :to="{name:'news'}">Noticias</b-dropdown-item>
                        <b-dropdown-item :to="{name:'openings'}">Openings</b-dropdown-item>
                        <b-dropdown-item @click="$store.dispatch('logout')" v-show="$store.getters.auth"
                        >Cerrar sesión
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <!--<b-nav-item :to="{name:'manga'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Manga
                    </b-nav-item>-->
                    <!--<b-nav-item :to="{name:'doramas'}" v-show="$store.getters.auth" exact exact-active-class="active">
                        Doramas
                    </b-nav-item>-->
                    <b-nav-item :to="{name:'login'}" v-show="$store.getters.guest" exact>Login</b-nav-item>
                    <!--<b-nav-item @click="$store.dispatch('logout')" v-show="$store.getters.auth">Logout
                    </b-nav-item>-->
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-form v-show="$store.getters.auth" @submit.prevent="searchOnDirectory">
                        <b-form-input size="sm" class="mr-sm-2" placeholder="¿Qué anime buscas?"
                                      v-model="query"></b-form-input>
                        <b-button variant="success" size="sm" class="my-2 my-sm-0" type="submit">Buscar
                        </b-button>
                    </b-nav-form>
                </b-navbar-nav>
            </b-collapse>
        </b-container>
    </b-navbar>
</template>

<script>
    export default {
        name: "navbar",
        data() {
            return {
                query: null,
                showMenu: false,
            }
        },
        mounted() {

        },
        methods: {
            searchOnDirectory() {
                this.$router.replace({name: 'directory', query: {keyword: this.query}});
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
                document.querySelector('#dropdown-menu').style.display = this.showMenu ? 'block' : 'none';
            },
        },
    }
</script>

<style scoped>
    .purple-background {
        background: #673bb7 !important;
    }

    .nav-link,
    .nav-link > span {
        color: snow !important;
    }

    .active {
        font-weight: bold !important;
    }

    #my-nav-dropdown > a.nav-link > span {
        color: snow !important;
    }
</style>
